// extracted by mini-css-extract-plugin
export default {"container":"style_container__Z7bE3","innerBox":"style_innerBox__kFIbK"};